import {createAction, props} from "@ngrx/store";
import {RoleDto} from "@esa/api/models/RoleDto";

export const getRoles = createAction(
  '[Roles] Get Roles',
)
export const getRolesSuccess = createAction(
  '[Roles] Get Roles Success',
  props<{ roles: RoleDto[] }>()
)
export const getRolesError = createAction(
  '[Roles] Get Roles Error',
)
